// src/MessageList.tsx
import React, { useRef, useEffect } from "react";
import MessageBubble from "./MessageBubble.tsx";

interface Message {
  sender: string;
  text: string;
  timestamp?: string;
}

interface Props {
  messages: Message[];
  username: string;
  colors: any;
}

const MessageList: React.FC<Props> = ({ messages, username, colors }) => {
  const messagesEndRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  return (
    <div
      style={{
        flexGrow: 1,           // take available space
        minHeight: 400,        // don't go below 400px
        maxHeight: 650,        // cap at 650px
        overflowY: "auto",     // scroll if content exceeds height
        padding: 20,
      }}
    >
      {messages.map((msg, i) => (
        <MessageBubble
          key={i}
          sender={msg.sender}
          text={msg.text}
          timestamp={msg.timestamp}
          isOwn={msg.sender === username}
          colors={colors}
        />
      ))}
      <div ref={messagesEndRef} />
    </div>
  );
};

export default MessageList;
